<div *ngIf="icon; else textCommand" fxFlex>
    <forge-icon-button fxFlex [disabled]="!isEnabled" [dense]="dense" (click)="action($event)" [ngClass]="class"
                       [attr.aria-label]="ariaLabel" isTelemetryCommand="true" [attr.telemetry]="ariaLabel" [attr.theme]="theme">
        <forge-icon [attr.name]="icon" [ngStyle]="{'--forge-icon-color': iconColor}"></forge-icon>
        {{label}}
    </forge-icon-button>

    <forge-tooltip *ngIf="isEnabled && tooltip" [placement]="tooltipDirection">
        {{tooltip}}
    </forge-tooltip>

    <forge-tooltip *ngIf="!isEnabled && disabledTooltip" placement="bottom">
        {{disabledTooltip}}
    </forge-tooltip>
</div>

<ng-template #textCommand>
    <forge-button fxFlex variant="outlined" [dense]="compactMode" [disabled]="!isEnabled" (click)="action($event)"
                  [attr.telemetry]="ariaLabel" isTelemetryCommand="true" [attr.aria-label]="ariaLabel" class="command-forge-button">
        {{label}}
        <forge-circular-progress *ngIf="isWaiting" slot="end"></forge-circular-progress>
    </forge-button>
</ng-template>
